import React from 'react'
import { observer } from 'mobx-react-lite'

import { AccountStoresForm } from './AccountStoresForm'

import { useApi } from '../hooks/storeHook'

import { required } from '../common/objectUtils'

import { OzonAccountProps } from '../types/accountProps'

export const OzonStoresForm =
  observer(
    ({account}: OzonAccountProps) => {
      const api = useApi()

      return <AccountStoresForm
        account={account}
        initStoreCargoType={(store, editStoreBase) => ({...editStoreBase, isKgt: store.isKgt})}
        updateStoreCargoType={(editStore, warehouse) => editStore.isKgt = warehouse.isKgt}
        filterWhByCargoType={(warehouse, formStores) => formStores.every(store => store.isKgt !== warehouse.isKgt)}
        loadStores={api.userSync.getOzonStores}
        loadWarehouses={api.userSync.getOzonWarehouses}
        editStores={api.userSync.editOzonStores}
        whKeySelector={_ => required(_.id)}
        storeWhKeySelector={_ => required(_.warehouseId)}
        formatWarehouseNameHint={warehouse => warehouse.isKgt ? ' [КГТ]' : ''}
      />
    })